import React, { Component } from "react";
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import SearchBusinessPartners from "../../Common/SearchBusinessPartners";
import { SearchPayloadType } from "../../BusinessPartnerLists/types";
import { CountryType } from "../../BusinessPartnerDetails/types";
import { SearchStateType } from "../types";
import { generateSearchUrlParam } from "../../../utils";

interface IProps extends RouteComponentProps<any> {
  bpList: any[];
  searchBPSucceeded: boolean;
  countries: CountryType[];
  searchBP: (searchPayload: SearchPayloadType) => any;
  clearBPLists: () => any;
  setMenuKey: (key: string) => any;
  fetchLookUp: () => void;
  resetSearchBPSucceededFlag: () => void;
}

interface IStates {
  searchText: string;
  searchObj: SearchStateType | null;
}

const initialState = {
  searchText: null,
  searchObj: null,
};

const defaultSeachPayload = {
  sortBy: "",
  isSortAscending: true,
  page: 1,
  pageSize: 15,
  searchData: [],
};

class SearchHomeComponent extends Component<IProps, IStates> {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    const {
      location: { pathname },
      countries,
    } = this.props;
    const menuKey = pathname.replace(/\//gi, "").replace(/-/gi, " ");
    const { setMenuKey, clearBPLists, fetchLookUp } = this.props;

    setMenuKey(menuKey);
    clearBPLists();
    // fetch lookups
    if (countries === null) fetchLookUp();
  }

  componentWillUnmount() {
    const { resetSearchBPSucceededFlag } = this.props;
    resetSearchBPSucceededFlag();
  }

  searchBP = (searchObj: SearchStateType) => {
    const searchPayload = {
      ...defaultSeachPayload,
      searchObj,
    };
    this.setState({ searchObj });
    const { searchBP } = this.props;
    searchBP(searchPayload);
  };

  onSearchInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  render() {
    const { countries, bpList, searchBPSucceeded } = this.props;
    const { searchText, searchObj } = this.state;
    if (bpList && bpList.length && searchBPSucceeded) {
      const params = generateSearchUrlParam({
        searchObj,
        ...defaultSeachPayload,
      });
      return <Redirect to={`/search/?${params}`} push={false} />;
    }
    return (
      <div className="search-home-wrap">
        <div className="search-home-inner">
          <SearchBusinessPartners
            searchBP={this.searchBP}
            onSearchInputChange={this.onSearchInputChange}
            searchQuery=""
            searchText={searchText}
            countries={countries}
          />
          {searchBPSucceeded && bpList.length === 0 && searchObj !== null && (
            <span className="bp-notfound-info">
              Business Partner was not found.
              <Link to="/business-partner-details"> + Create new</Link>
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default SearchHomeComponent;
